import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import config from "../../../config/config";
import { getAuthToken } from "../../../utils/token";
import Loader from "../../loader/Loader";
const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#0d6efd",
      color: "white",
      fontWeight: "bold",
      fontSize: "14px",
    },
  },
};

export default function Attendance() {
  const [dataList, setDataList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [listLoading, setListLoading] = useState(false);

  useEffect(() => {
    fetchAttendance();
  }, []);

  const fetchAttendance = async () => {
    const token = getAuthToken();
    if (!token) return;

    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/admin/getattendance`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDataList(res.data.attendances || []);
    } catch (err) {
      console.error("Error fetching attendance:", err);
      toast.error("Failed to load attendance data");
    } finally {
      setListLoading(false);
    }
  };

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "80px" },
    { name: "User Id", selector: (row) => row.userId, sortable: true },
    { name: "Company", selector: (row) => row.company, sortable: true },
    { name: "Comp Code", selector: (row) => row.compCode, sortable: true },
    { name: "Emp ID", selector: (row) => row.empId, sortable: true },
    { name: "Employee Name", selector: (row) => row.empName, sortable: true },
    { name: "Department", selector: (row) => row.department, sortable: true },
    { name: "Grade", selector: (row) => row.grade, sortable: true },
    { name: "Date", selector: (row) => row.attDate, sortable: true },
    { name: "Shift Start", selector: (row) => row.shiftStart, sortable: true },
    { name: "Check In", selector: (row) => row.checkIn, sortable: true },
    { name: "Check Out", selector: (row) => row.checkOut, sortable: true },
    { name: "Total Hours", selector: (row) => row.totalHours, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
  ];

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong className="mb-0 fs-4">Attendance Details</strong>
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{ width: "200px" }}
        />
      </div>

      {listLoading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={dataList.filter((item) =>
            Object.values(item)
              .join(" ")
              .toLowerCase()
              .includes(filterText.toLowerCase())
          )}
          pagination
          highlightOnHover
          customStyles={customStyles}
        />
      )}
    </div>
  );
}
